var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class RecentlyViewed extends Component {
    constructor() {
        super('RecentlyViewed', false);
        this.products = [];
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if ($('body').hasClass('single-product')) {
                const rawRecentlyViewed = sessionStorage.getItem('recentlyViewed');
                try {
                    this.products = JSON.parse(rawRecentlyViewed);
                }
                catch (e) {
                    this.products = [];
                }
                if (this.products == null)
                    this.products = [];
                this.displayProducts();
                this.addProduct();
            }
            this.success();
        });
    }
    addProduct() {
        const id = parseInt($('#product-data .id').text());
        if (id != this.getLastProductId()) {
            const product = {
                id: id,
                link: window.location.href,
                thumbnail: $('#product-data .thumbnail').text(),
                title: $('#product-data .title').text(),
                subtitle: $('#product-data .subtitle').text(),
            };
            this.products.unshift(product);
            if (this.products.length > 6) {
                this.products.pop();
            }
            sessionStorage.setItem('recentlyViewed', JSON.stringify(this.products));
        }
    }
    getLastProductId() {
        return this.products.length > 0 ? this.products[0].id : false;
    }
    displayProducts() {
        if (this.products.length > 0) {
            $('#recently-viewed').removeClass('d-md-none').addClass('d-md-block');
            this.products.forEach((product, index) => {
                const productElement = $('#recently-viewed .product').eq(index);
                productElement.find('.ratio').css('background-image', 'url(\'' + product.thumbnail + '\')');
                productElement.find('a').attr('href', product.link);
                productElement.find('h1').text(product.title);
                productElement.find('.fs-small').text(product.subtitle);
                productElement.removeClass('d-none');
            });
            $('#recently-viewed .stretched-link[href=""]').addClass('d-none');
        }
    }
}
